/* eslint-disable */
import axios from "axios";
import {
  parsePhoneNumberFromString
} from "libphonenumber-js";
import config from '../api_config.json';
import moment from 'moment';
import {
  EmitPreventCheckin,
  EmitCloseModal
} from './event-bus';
import printerCache from './cache';
import DymoPrintHelper from './dymoPrint';
var TheCurrentPrinter=null;


// import ct from 'countries-and-timezones';
export const getCheckInDataMixin = {
  data() {
    return {
      actionTimer: 0,
      actionTaken: false,
      isMounted: false,
      userData: {
        visitor: {
          name: null,
          email: null,
          mobile: null,
          contactType: null
        },
        questions: {}
      },
      locationData: {},
      rememberMe:{},
      deviceCode:null, 
      print: {
        environment: null,
        printers: null
      },
      printerHelper: null,
      printerCache
    };
  },
  computed: {
    countryCode() {
      console.log('Triggered:', new Date());
      if (!this.isMounted) return "NZ";
      const visitor = this.userData.visitor;
      try {
        if (visitor) {
          if (visitor.mobile) return parsePhoneNumberFromString(visitor.mobile).country;
        }

        const location = (this.data ? this.data.location : null) || this.$root.location;
        if (location && location.address && location.address.country && location.address.country.countryCode) return location.address.country.countryCode;
        return "NZ"
      } catch (e) {
        return "NZ";
      }
    },
    isKiosk() {
      return window.IS_KIOSK;  
    },
    showWelcomeScreen() {
      return this.isKiosk || config.showWelcomeScreen;
    }
  },
  created() { },
  methods: {
    getLocalPost(getLocalPostCallback) {
      if (localStorage.getItem("userVisitorData")) {
        try {
          this.userData.visitor = JSON.parse(
            localStorage.getItem("userVisitorData")
          );

          getLocalPostCallback(this.userData);
        } catch (e) {
          console.log("localStorage parse error");
          getLocalPostCallback(this.userData);
        }
      } else {
        getLocalPostCallback(this.userData);
      }
    },
    getCheckInData(locationId, successCallback, userData) {
      console.log("userData", userData);
      const me = this;
      // if (me.$root.location && (locationId || '').toLowerCase() === me.$root.location.code.toLowerCase()) {
      //   this.data = me.$root.location;
      //   successCallback(me.$root.location);
      //   return;
      // }
      this.state.isLoading = true;
      axios
        .get("/actions/" + locationId, {
          params: {
            ...(userData && userData.visitor.mobile ? {
              mobile: userData.visitor.mobile
            } : {}),
            ...(userData && userData.visitor.email && document.querySelectorAll('[type="email"]').length > 0 ? {
              email: userData.visitor.email
            } : {})
          }
        })
        .then(async function (response) {
          console.log("response", response);
          if (response.data) {
            try {
              // ADDING LOCATION DATA
              console.log("response.data.location >>> ", response);
              me.locationData = response.data.location;
              me.rememberMe = response.data.rememberMe;
              me.deviceCode = response.data.code;

              console.log("me.locationData >>> ", me);
            } catch (e) {
              console.log("no location");
            }

            try {
              localStorage.setItem("signInCode", response.data.code);
            } catch (e) {
              console.log('no code')
            }

            try {
              // B: REMOVING APP ICONS WHEN NEW LOCATION CODE
              if (localStorage.getItem("signInCode") !== response.location.code) {
                localStorage.removeItem("appIcons");
              }

              // B: ADDING APP ICONS OF LOCATION
              if (localStorage.getItem("appIcons") === null) {
                console.log("appIcons >>> ", response.data.appIcons);
                localStorage.setItem("appIcons", JSON.stringify(response.data.appIcons));
              }
            } catch (e) {

            }

            if (response.data.action === "checkout") {
              const responseData = response.data.data;
              if ((response.data.location || {}).branding) me.$parent.setBranding(response.data.location.branding);
              const paramsId = responseData && responseData.checkout ? responseData.checkout.url : locationId;
              if (me.$route.name === 'signout' && successCallback) successCallback(response.data)
              else {
                me.$router.push({
                  name: "signout",
                  params: {
                    id: paramsId,
                    checkout: Boolean(responseData && responseData.checkout)
                  }
                }).catch(() => { });
              }
            } else {
              if (response.data.location) {
                if ((response.data.location || {}).branding) me.$parent.setBranding(response.data.location.branding);
                me.data = response.data.location;
                me.$root.location = response.data.location;
                me.$parent.pageTitle(
                  (me.data.branding || {}).name || '' +
                  " - " +
                  me.data.name +
                  " " +
                  me.pageName
                ); //Dynamically Set PageTitle

               const device = response.data.device;
               var printerHelper = await me.getPrinter.bind(me)(device);
               console.log("Printer found", printerHelper);
               me.printerHelper = printerHelper;
               TheCurrentPrinter = printerHelper;

                successCallback(response.data.location);
              } else if (response.data.data && response.data.data.checkout) {
                //set form sent flag so its not resent
                response.data.data.message = response.data.message;
                me.data = response.data.data;
                me.$root.location = response.data.location;
                console.log(me.$route);
                // No Location data

                me.$parent.errorMsg = response.data.message;
                me.$router.push({
                  name: "signout",
                  params: {
                    id: me.data.checkout.url,
                    checkout: Boolean(me.data && me.data.checkout),
                    mobile: response.data.visit.visitor.mobile
                  }
                });

                successCallback(response.data.data);
              } else if (response.data.message) {
                // No Location data
                me.$parent.errorMsg = response.data.message;
                me.$router.push({
                  name: "home"
                });
              }
            }
          } else {
            console.log("getProductItems fail");
          }
          me.state.isLoading = false;
        })
        .catch(function (error) {
          console.log("error", error);
          me.$parent.errorMsg = error;
          if (error.response && error.response.data) {
              if (error.response.data.message) {
                me.$parent.errorMsg = error.response.data.message;
              }
              if (!error.response.data.location) {
                me.$router.push({
                  name: "home"
                });
              }
          }
          me.state.isLoading = false;
          if (error.response.status === 406) {
            const { response } = error
            const responseData = response.data;
            const paramsId = responseData && responseData.checkout ? responseData.checkout.url : locationId;
            me.$router.push({
              name: "signout",
              params: {
                id: paramsId
              }
            }).catch(() => { });
            me.state.formCompleted = true;
          }
        });
    },
    postCheckInData(userData) {
      console.log("postCheckInData userData >>> ", userData);
      let me = this;
      this.state.isLoading = true;

      delete userData.dependants;
      if (userData.visitor.hasDependants === true && userData.visitor.dependants) {
        userData.dependants = parseInt(userData.visitor.dependants);
      }

      const checkInUrl = "/locations/" + me.data.id + "/checkin";

      axios
        .post(checkInUrl, userData)
        .then(async function (response) {
          console.log("SignIn Response", response);
          me.state.isLoading = false;
          if (response.data && response.data.success) {
            me.state.isLoading = true;
            await me.printLabel.bind(me)(response.data);
            me.state.isLoading = false;
            console.log("SignIn Response good", response.data);

            //set form sent flag so its not resent
            response.data.data.message = response.data.message;
            //response.data.data.code = response.data.location.code;
            localStorage.setItem(
              "userFormSentData",
              JSON.stringify(response.data.data)
            );
            me.$parent.errorMsg = me.isKiosk ? '' : response.data.message;

            // B: REMOVING QR CODE CONTENT
            me.removeQrCodeContent();

            me.$router.push({
              name: "signout",
              params: {
                id: response.data.data.checkout.url,
                checkout: Boolean(response.data.data && response.data.data.checkout)
              }
            });

          } else {
             // B: REMOVING QR CODE CONTENT
            me.removeQrCodeContent();

            me.flashMessage.error({
              title: 'Error',
              message: ((response || {}).data || {}).message || 'Something went wrong.. Please check console'
            });
          }
        })
        .catch(function (error) {
          const {
            response
          } = error;
          me.state.isLoading = false;

          // B: REMOVING QR CODE CONTENT
          me.removeQrCodeContent();

          if (response && response.status === 405) {
            return EmitPreventCheckin(response.data);
          }

          me.flashMessage.error({
            title: 'Error',
            message: ((response || {}).data || {}).message || error.message
          });
        });
    },
    resetActionTimer() {
      this.actionTimer = 0;
    },
    async getPrinter(data) {
      console.log('getPrinter...', data);
      let printer = data?.printer;
      if (!printer) return null;

      const printerCache = this.printerCache;
      return await new Promise(resolve => {
        const value = printerCache.get(printer.id, async () => {
          console.log('NEW PRINTER');
          const newPrinter = new DymoPrintHelper(this, printer);
          await newPrinter.init().then(() => {
            printerCache.set(printer.id, newPrinter)
          })
          resolve(newPrinter)
          return
        })

        if (!(value instanceof Promise)) resolve(value)
      });
    },
    async printLabel(data) {
      let me = this;
          console.log("printLabel called", data );
          console.log("TheCurrentPrinter", TheCurrentPrinter);
          if ( TheCurrentPrinter ) {
            return await TheCurrentPrinter.print(data);
          }
      },
    redirectToStart() {
      console.log('REDIRECT');
      EmitCloseModal()
      const signInData = JSON.parse(localStorage.getItem("userFormSentData"))
      const signInCode = localStorage.getItem("signInCode");
      localStorage.removeItem('userVisitorData');
      const code = (signInData || {}).code || signInCode;
      this.$router.push(code ? `/${code}` : '/')
      .catch(() => {
        if (this.goBack) this.goBack();
      });
    },
    removeQrCodeContent() {
      console.log("removeQrCodeContent >>> ");
      sessionStorage.removeItem("qrCodeContent");
    }
  },
  mounted() {
    this.isMounted = true;
    this.$nextTick(() => {
      if (window.location.hostname.includes('kiosk.')) {
        if (this.$route.name !== 'home') {
          window.addEventListener('keypress', this.resetActionTimer);
          window.addEventListener('scroll', this.resetActionTimer);
          this.$root.$el.addEventListener('touchstart', this.resetActionTimer);
          this.$root.$el.addEventListener('touchmove', this.resetActionTimer);
          this.$root.$el.addEventListener('mouseover', this.resetActionTimer);
          this.$root.$el.addEventListener('click', this.resetActionTimer);

          console.log('Start watching keypress/scroll/touchstart/touchmove/mouseover/click', this);
        }
      }
    })
  },
  watch: {
    'state.isLoading'(value) {
      this.isMounted = !value;
    },
    actionTimer: {
      handler(value) {
        if (window.location.hostname.includes('kiosk.')) {
          if (this.$route.name !== 'home') {
            clearTimeout(this.refreshTimeOut);
            if (value < 60) {
              this.refreshTimeOut = setTimeout(() => {
                this.actionTimer++;
              }, 1000);
            } else this.redirectToStart()
          }
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  }
};
